"use strict";Object.defineProperty(exports, "__esModule", { value: true });exports.default = void 0;require("core-js/modules/es6.regexp.split");require("core-js/modules/es6.object.keys");require("core-js/modules/web.dom.iterable");
































































var _formatter = require("@/utils/formatter");
var _validate = require("@/utils/validate"); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = { data: function data() {return { searchData: { platform: '', address: '', page: 1, rows: 10 }, //过滤表单
      pageData: { page: 1, rows: 10, total: 0, pages: 1 }, //分页数据
      appList: [], //App列表
      showAdd: false, //是否显示新增||编辑弹窗
      tableColumn: [{ prop: 'platform', label: 'App名称(AppId)' }, { prop: 'type', label: '通知类型', formatter: _formatter.msgFeedbackNoticeType }, { prop: 'address', label: '收件人邮箱', formatter: _formatter.msgFeedbackEmails }, { prop: 'remark', label: '备注' }], //表格表头信息
      tableData: [], //表格数据
      typeList: [{ id: 1, name: '意见反馈' }], //通知类型列表
      feedbackForm: { id: '', type: '', platform: '', address: '', remark: '' }, //新增||编辑表单
      feedbackRule: { type: [{ required: true, message: '请选择反馈通知类型', trigger: 'change' }], platform: [{ required: true, message: '请选择App', trigger: ['change'] }], address: [{ required: true, message: '请填写收件人通知邮箱', trigger: ['change', 'blur'] }] //表单验证规则
      } };}, mounted: function mounted() {this.fetchAppList();
    this.fetchFeedbackList();
  },

  methods: {
    /**
              * 获取App列表
              */
    fetchAppList: function fetchAppList() {var _this = this;
      this.getData('/api/faPlat', { page: 1, rows: 999999 }, function (res) {
        _this.appList = res.list;
      });
    },

    /**
        * 获取意见反馈列表
        */
    fetchFeedbackList: function fetchFeedbackList() {var _this2 = this;
      var params = Object.assign({}, this.searchData);
      this.getData('/api/mailReceiver/getAll', params, function (res) {
        _this2.tableData = res.list;
        _this2.pageData.page = res.pageNum;
        _this2.pageData.total = res.total;
      });
    },

    /**
        * 重置
        */
    onClickReset: function onClickReset() {
      this.$set(this.searchData, 'platform', '');
      this.$set(this.searchData, 'address', '');
      this.$set(this.searchData, 'pageIndex', 1);
      this.fetchFeedbackList();
    },

    /**
        * 编辑
        */
    editItem: function editItem(row) {
      this.showAdd = true;
      this.$set(this.feedbackForm, 'id', row.id);
      this.$set(this.feedbackForm, 'type', row.type);
      this.$set(this.feedbackForm, 'platform', row.platform);
      this.$set(this.feedbackForm, 'address', row.address.join(';'));
      this.$set(this.feedbackForm, 'remark', row.remark);
    },

    /**
        * 删除
        */
    delItem: function delItem(row) {var _this3 = this;
      this.$confirm('确定删除当前意见反馈？', '提示', { type: 'warning' }).then(function (res) {
        //删除意见反馈
        _this3.delData("/api/mailReceiver/delete/".concat(row.id), {}, function (res) {
          _this3.fetchFeedbackList();
        });
      }).catch(function (err) {

      });
    },

    /**
        * size-change
        */
    handleSizeChange: function handleSizeChange(val) {
      this.$set(this.searchData, 'pageSize', val);
      this.$set(this.searchData, 'pageIndex', 1);
      this.fetchFeedbackList();
    },

    /**
        * Page-change
        */
    handleCurrentChange: function handleCurrentChange(val) {
      this.$set(this.searchData, 'pageIndex', val);
      this.fetchFeedbackList();
    },

    /**
        * 弹窗打开
        */
    onAddDialogOpen: function onAddDialogOpen() {var _this4 = this;
      this.$nextTick(function () {
        _this4.$refs.feedbackForm.clearValidate();
      });
    },

    /**
        * 弹窗关闭
        */
    onAddDialogClose: function onAddDialogClose() {var _this5 = this;
      this.$nextTick(function () {
        Object.keys(_this5.feedbackForm).forEach(function (e) {
          _this5.$set(_this5.feedbackForm, e, '');
        });
        _this5.$refs.feedbackForm.clearValidate();
      });
      this.showAdd = false;
    },

    /**
        * 邮箱输入框-blur
        */
    onAddressBlur: function onAddressBlur() {
      var list = this.feedbackForm.address.split(';');
      list.forEach(function (e, index) {
        if (!(0, _validate.validEmail)(e)) {
          list.splice(index, 1);
        }
      });
      this.$set(this.feedbackForm, 'address', list.join(';'));
    },

    /**
        * 保存
        */
    onSaveFeedback: function onSaveFeedback() {var _this6 = this;
      this.$refs.feedbackForm.validate(function (valid) {
        if (valid) {
          var params = Object.assign({}, _this6.feedbackForm);
          params.address = params.address.split(';');
          if (params.id) {
            //编辑
            _this6.putData('/api/mailReceiver/update', params, function (res) {
              _this6.onAddDialogClose();
              _this6.fetchFeedbackList();
            });
          } else {
            //新增
            delete params['id'];
            _this6.postData('/api/mailReceiver/save', params, function (res) {
              _this6.onAddDialogClose();
              _this6.fetchFeedbackList();
            });
          }
        }
      });
    } } };exports.default = _default;